import { render, staticRenderFns } from "./VehiclesList.vue?vue&type=template&id=70920d29&"
import script from "./VehiclesList.vue?vue&type=script&lang=js&"
export * from "./VehiclesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports